/**
 * Detect "scanned bundle A → forgot skid → scanned bundle B" — the workflow
 * the packaging operator complained about. The bundle session transitions
 * silently from A to B and A's skid never gets scanned, so the operator walks
 * away thinking everything is recorded when bundle A is still loose on the
 * pallet.
 *
 * We have two signals that A actually did get a skid:
 *
 *  - `committedForPrev` — the side-sheet's commit() path stamps this ref with
 *    the bundle id at the moment a skid scan is *attempted* (covers wrong-
 *    skid, already-complete, and successful paths). Synchronous; doesn't wait
 *    for the server.
 *  - `prevBundleSkidId` — read from the cached orders. Catches the inline
 *    `BundleSkidIdCell` path (which doesn't go through the side-sheet
 *    commit()) once that mutation's invalidation has landed in the cache.
 *
 * Either signal is enough to suppress the warning. Both null AND the bundle
 * actually changed → operator skipped a step.
 */
export function shouldWarnInterruptedScan(args: {
  prevBundleId: number | null | undefined
  newBundleId: number | null | undefined
  committedForPrev: number | null
  prevBundleSkidId: number | null | undefined
}): boolean {
  const { prevBundleId, newBundleId, committedForPrev, prevBundleSkidId } = args
  if (prevBundleId == null) return false
  if (newBundleId == null) return false
  if (prevBundleId === newBundleId) return false
  if (committedForPrev === prevBundleId) return false
  if (prevBundleSkidId != null) return false
  return true
}
